import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=26b7512c&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign({QPage}, component.options.components || {})
